<template>
  <div class="modal fade in show" tabindex="-1" role="dialog">
    <div
      class="modal-dialog"
      role="document"
      v-if="step === 1"
      style="width: 1100px"
    >
      <div class="modal-content">
        <div class="modal-header">
          <button
            type="button"
            class="close"
            v-on:click="$parent.showSendProjectDialog = false"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
          <h4 class="modal-title">
            Заверение об обстоятельствах, имеющих значение для заключения
            договора
          </h4>
        </div>
        <div class="modal-body">
          <p>
            1.1. Размещая данные проекта в Личном кабинете, Заявитель
            подтверждает, что он знаком с требованиями Стандартов деятельности
            Фонда развития промышленности (далее – Фонд), его Уставом и
            нормативными актами, регулирующими деятельность Фонда. Заявителю
            известны рекомендации и требования Фонда к составу и содержанию
            документов проекта, изложенные на сайте Фонда в разделе «Займы»,
            Заявитель принимает указанные требования в полном объеме и
            обеспечивает готовность документов в соответствии с правилами и
            рекомендациями.
          </p>
          <p>
            1.2. Заявитель подтверждает, что на дату подачи документов проекта в
            отношении Заявителя, Поручителя, Залогодателя, Соисполнителя по
            проекту отсутствует процедура банкротства, ликвидации или
            реорганизации.
          </p>
          <p>
            1.3. Заявитель подтверждает, что на дату подачи документов в
            отношении него отсутствуют открытые судебные разбирательства или
            неурегулированные требования, прямо влияющие на реализацию проекта
            или в объеме, превышающем 10% стоимости активов Заемщика.
          </p>
          <p>
            1.4. Заявитель подтверждает, что он ознакомлен с типовыми формами
            договоров целевого займа, поручительства, договоров ипотеки
            недвижимого имущества и залога оборудования, размещенных на сайте
            Фонда. Смысл, содержание указанных договоров понятны, основные
            условия указанных договоров известны. Заявитель извещен и принимает
            следующие условия: заем предоставляется Фондом всем Заемщикам на
            одинаковых условиях в соответствии с программами Фонда, и ему не
            могут быть предоставлены преференции по сравнению с другими
            Заемщиками, установленные в типовых формах договоров.
          </p>
          <p>
            1.5. Заявитель не имеет просроченной задолженности перед Фондом,
            кредитными организациями, задолженности по выделенным из
            государственного бюджета субсидиям, государственным займам и
            инвестиционным контрактам, а также подтверждает, что по ранее
            полученным им средствам субсидий из государственного бюджета
            отсутствовали факты нарушения им целевого использования средств, а
            также неисполнения или ненадлежащего исполнения им сроков возврата
            средств субсидии.
          </p>
          <p>
            1.6. За внесение существенных изменений в условиях проекта после
            подписания договора целевого займа может взиматься плата. С
            подробной информацией можно ознакомиться в Стандарте Фонда «Порядок
            отбора и финансирования проектов» и в договоре.
          </p>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-default"
            data-dismiss="modal"
            @click="step = 2"
          >
            Подтверждаю
          </button>
        </div>
      </div>
      <!-- /.modal-content -->
    </div>
    <div
      class="modal-dialog"
      role="document"
      v-if="step === 2"
      style="width: 800px"
    >
      <div class="modal-content">
        <div class="modal-header">
          <button
            type="button"
            class="close"
            v-on:click="$parent.showSendProjectDialog = false"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
          <h4 class="modal-title">
              Отправка данных резюме в другие институты развития
          </h4>
        </div>
        <div class="modal-body">
          <p>
            <strong>Моя компания хочет, чтобы:</strong>
          </p>
          <p>
            Информация, содержащаяся в настоящем резюме проекта, была доступна
            для других институтов развития и иных инвесторов - партнеров Фонда.
            Подтверждаю, что данная информация не является конфиденциальной.
          </p>
          <p></p>
          <p style="color: red;font-weight: bold;">
            Данный Вами ответ никаким образом не влияет на возможность отправить
            заявку на рассмотрение в ФРП
          </p>
          <p style="text-align: center">
            <label for="UF_IS_OTHER_INSTITUT_1"
              ><input
                id="UF_IS_OTHER_INSTITUT_1"
                type="radio"
                v-model="$parent.project.UF_IS_OTHER_INSTITUT"
                value="1"
                name="UF_IS_OTHER_INSTITUT"
              />
              Да</label
            >

            &nbsp;&nbsp;
            <label for="UF_IS_OTHER_INSTITUT_2"
              ><input
                id="UF_IS_OTHER_INSTITUT_2"
                type="radio"
                v-model="$parent.project.UF_IS_OTHER_INSTITUT"
                value="0"
                name="UF_IS_OTHER_INSTITUT"
              />
              Нет</label
            >
          </p>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-default"
            data-dismiss="modal"
            @click="toStep3"
          >
            Далее
          </button>
        </div>
      </div>
      <!-- /.modal-content -->
    </div>
    <div
      class="modal-dialog"
      role="document"
      v-if="step === 3"
      style="width: 800px"
    >
      <div class="modal-content">
        <div class="modal-header">
          <button
            type="button"
            class="close"
            v-on:click="$parent.showSendProjectDialog = false"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
          <h4 class="modal-title">
            Из какого источника Вы узнали о Фонде?
          </h4>
        </div>
        <div class="modal-body">
          <ul style="list-style: none">
            <li v-for="item in sourceInformations">
              <span v-if="item.CHILD.length === 0"
                ><label style="font-weight: normal"
                  ><input
                    v-model="$parent.project.UF_SOURCE_INF_ID"
                    type="radio"
                    :value="item.ID"
                    name="source_information"
                  />
                  {{ item.NAME }}</label
                ></span
              >
              <strong v-if="item.CHILD.length > 0">{{ item.NAME }}:</strong>
              <ul style="list-style: none" v-if="item.CHILD.length > 0">
                <li v-for="child in item.CHILD">
                  <label style="font-weight: normal"
                    ><input
                      type="radio"
                      v-model="$parent.project.UF_SOURCE_INF_ID"
                      :value="child.ID"
                      name="source_information"
                    />
                    {{ child.NAME }}</label
                  >
                </li>
              </ul>
            </li>
            <div>
              <br />
              <textarea
                v-model="$parent.project.UF_SOURCE_INF_TEXT"
                class="txar i-main-style t-dop-style i-wid-50"
                style="width: 80%"
                v-if="isCommentNeed"
              ></textarea>
            </div>
          </ul>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-default"
            data-dismiss="modal"
            @click="step = 4"
            :disabled="
              $parent.project.UF_SOURCE_INF_ID === null ||
                $parent.project.UF_SOURCE_INF_ID == 0 ||
                (this.isCommentNeed &&
                  this.$parent.project.UF_SOURCE_INF_TEXT === '')
            "
          >
            Далее
          </button>
        </div>
      </div>
      <!-- /.modal-content -->
    </div>

    <div
      class="modal-dialog"
      role="document"
      v-if="step === 4"
      style="width: 800px"
    >
      <div class="modal-content">
        <div class="modal-header">
          <button
            type="button"
            class="close"
            v-on:click="$parent.showSendProjectDialog = false"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
          <h4 class="modal-title">
            Поделитесь Вашим мнением
          </h4>
        </div>
        <div class="modal-body">
          <p class="cnt-h"><b>Уважаемые заявители!</b></p>
          <p>
            Мы постоянно работаем над повышением удобства наших сервисов.
            Ответив на несколько вопросов о процессе заполнения резюме проекта,
            вы поможете нам стать лучше.
          </p>
          <p class="cnt-h">
            <a href="http://simpoll.ru/run/survey/a856c1db" target="_blank"
              >Оцените процесс заполнения резюме</a
            >
          </p>
          <p>Спасибо!</p>
          <!--<iframe src="https://simpoll.ru/run/survey/a856c1db" style="width: 100%; border: 0; min-height: 200px;"></iframe>-->
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-default"
            data-dismiss="modal"
            @click="setVideoUsefullValue()"
            :disabled="
              $parent.project.UF_SOURCE_INF_ID === null ||
                (this.isCommentNeed &&
                  this.$parent.project.UF_SOURCE_INF_TEXT === '')
            "
          >
            Отправить
          </button>
        </div>
      </div>
      <!-- /.modal-content -->
    </div>
  </div>
  <!-- /.modal -->
</template>

<script>
import { FETCH_DIRECTORY } from "@/store/actions.type";
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      step: 1,
      isVideoUseful: 0
    };
  },
  created() {
    this.$store.dispatch(FETCH_DIRECTORY, ["source_information"]);
  },
  computed: {
    isCommentNeed() {
      let ret = false;

      this.directory.source_information.forEach(function(item) {
        if (
          this.$parent.project.UF_SOURCE_INF_ID === item.ID &&
          item.IS_COMMENT_SET
        ) {
          ret = true;
        }
      }, this);
      return ret;
    },
    sourceInformations() {
      let f = [];
      this.directory.source_information.forEach(function(item) {
        if (typeof item.SECTION_ID === "undefined") {
          item["CHILD"] = [];
          f.push(item);
        } else {
          let sectionExists = false;
          f.forEach(function(it) {
            if (it.NAME === item.SECTION_NAME) {
              sectionExists = true;
            }
          });
          if (!sectionExists) {
            let items = {
              NAME: item.SECTION_NAME,
              CHILD: []
            };
            this.directory.source_information.forEach(function(it) {
              if (it.SECTION_ID === item.SECTION_ID) {
                items.CHILD.push(it);
              }
            });
            f.push(items);
          }
        }
      }, this);
      return f;
    },
    ...mapGetters(["project", "directory"])
  },
  methods: {
    toStep3() {
      if (
        this.$parent.project.UF_IS_OTHER_INSTITUT == 1 ||
        this.$parent.project.UF_IS_OTHER_INSTITUT == 0
      ) {
        this.step = 3;
      }
    },
    setVideoUsefullValue() {
      this.$parent.project.UF_IS_VIDEO_USEFUL = this.isVideoUseful;
      this.$parent.sendProject();
    }
  },
  name: "SendProjectDialog"
};
</script>

<style scoped></style>
